const bisForm = document.querySelector('.js-bis-form');

if (bisForm) {
    bisForm.addEventListener('submit', async e => {
        e.preventDefault();
        const email = bisForm.querySelector('input[name="email"]');
        const variantId = document.querySelector('.js-outofstock').getAttribute('variantid');

        const options = {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2024-07-15',
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                      type: 'profile',
                      attributes: {
                          email: email.value
                      }
                  },
                },
                channels: ['EMAIL']
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`
                  }
                }
              }
            }
          })
        };

        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UAkg6Y", options)
        .then(() => {
            document.querySelector('.js-outofstock-content').removeAttribute('data-active');
            document.querySelector('.js-outofstock-success').setAttribute('data-active', '');
            [...document.querySelectorAll('.js-bis-success')].map(success => success.setAttribute('data-active', ''));
            [...document.querySelectorAll('.js-bis-success-email')].map(emailInput => {
                emailInput.innerHTML = email.value
            });
            email.value = '';
        }).catch(error => {
            console.log(error)
        });
    });
}
